//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { axiosGet } from '../../../axios/axios.js'

export default {
  name: 'ReportStandardSpecificationDialog',
  props: {
    reportId: {
      type: Number,
      default: null
    },
    standardSpecification: {
      type: Array,
      default () {
        return null
      }
    }
  },
  data: function () {
    return {
      loading: false,
      loadedStandardSpecification: [],
      columns: [
        {
          name: 'tool',
          label: 'Название',
          align: 'left',
          field: row => row.tool && row.tool.name,
          sortable: true
        },
        {
          name: 'unit',
          label: 'Ед. изм.',
          align: 'left',
          field: row => (row.tool && row.tool.unit) || row.unit || (row.standard && row.standard.unit) || '',
          sortable: true
        },
        {
          name: 'count',
          label: 'Типовое количество',
          align: 'left',
          field: row => {
            const count = row.count != null ? row.count : (row.standard && row.standard.count)
            return count != null ? count : 'Нет данных'
          },
          sortable: true
        },
        {
          name: 'project',
          label: 'Проект',
          align: 'left',
          field: row => {
            const project = row.project || (row.standard && row.standard.project)
            return project && project.name ? project.name : 'Нет данных'
          },
          sortable: true
        }
      ]
    }
  },
  computed: {
    tableItems: function () {
      if (this.standardSpecification != null) {
        return this.standardSpecification
      }
      return this.loadedStandardSpecification
    }
  },
  created: function () {
    if (this.standardSpecification == null) {
      this.loadData()
    }
  },
  methods: {
    loadData: async function () {
      if (this.reportId == null) {
        return
      }
      this.loading = true
      try {
        await axiosGet({
          url: '/service/delta/report/standardSpecification?reportIds=' + this.reportId,
          onSuccess: (response) => {
            const result = response.data.result || []
            const entry = result.find(item => item.reportId === this.reportId || String(item.reportId) === String(this.reportId))
            this.loadedStandardSpecification = entry ? (entry.items || []) : []
          },
          onFailure: 'Ошибка получения типовой спецификации',
          msgTarget: this
        })
      } finally {
        this.loading = false
      }
    }
  }
}
